module.exports = __webpack_public_path__ + "1f14c2a8fd7c3da0d7eab0e3cce22792.svg";